// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"Places_layoutWrapper__WHxP9"};